export default __webpack_public_path__ + "static/font-b6310916ca7fed384760c2855f3433eb.woff2";